// 移动端工程项目
<template>
  <div class="cmain">
    <mheader></mheader>
    <div class="topimg"></div>
    <div class="center">
      <h1 class="title">工程项目质量全面提升过程咨询</h1>
      <p
        class="jianjie"
      >以工程项目为服务对象，以鲁班奖创建为目标，通过了解项目基本情况、匹配专家、拟定咨询建议书，四次现场和若干次在线和现场节点咨询，为客户提供技术、质量、安全、绿色施工、科技创新、管理提升等全过程技术支持，帮助客户强化质量意识、改善管理、完善工艺，持续改进、过程提升、一次成优。</p>
      <div class="one">
        <div class="oneimg"></div>
        <p>
          委托方需按照要求提供：工程类别、投资规模或建筑面积、使用功能、工期
          等资料，以及项目部组织构架、人员组成，技术、质量、安全、节能环保等体
          系建设，创优策划书和保证措施。经系统评估，筛选符合咨询条件的项目，纳
          入咨询服务。
        </p>
        <p>
          根据工程的类别、特点、难点、分部区域，匹配相应的咨询专
          家。专家在查阅委托方提供的施工组织设计、施工方案和相关资料的基础上，
          初步分析该工程应控制的重点部位、关键工艺及对应的施工方案编制情况，与
          委托方初步沟通，了解需求，制定咨询计划书。
        </p>
      </div>
      <div class="two">
        <div class="twoimg"></div>
        <p>
          对委托方提交的设计方案、施工组织设计、地基基础施工方案、技术质量安全、
          绿色施工、节能环保、信息化等策划书提出优化建议。查看现场，与相关人员
          面对面交流，回答委托方提出的问题，指出现场作业存在的问题和解决方案。
          查阅相关技术资料，有针对性地做一次专题培训，并对后续施工过程中应该注
          意的问题给予提示和指导，提交二阶段咨询建议书。
        </p>
      </div>
      <div class="three">
        <div class="threeimg"></div>
        <p>
          查看地基基础、主体结构的实体质量，查看各分部分项工程的样板实施情况；
          核查上一阶段问题整改和建议落实情况；了解项目在新技术应用、质量安全、
          绿色施工、节能环保、持续改进等方面的实施情况；与现场人员面对面交流，
          指出问题，提出改进建议和实施方法；查阅技术资料，就下一步主体结构、装
          饰装修（附属设施）和机电设备安装应注意的问题，提出相应的对策建议和预
          控措施。提交三阶段咨询建议书。
        </p>
      </div>
      <div class="four">
        <div class="fourimg"></div>
        <p>
          查看主体结构实体质量，检查分部分项工程的样板；核查上一阶段问题整改
          和建议落实情况；了解项目在科技创新、信息技术、新型建造方式等方面应
          用情况；与现场人员面对面交流，指出问题，提出整改建议；查阅技术资料
          ，就下一步装饰装修（附属设施）和机电设备作业提出优化建议。提交
          四阶段咨询建议书。
        </p>
      </div>
      <div class="five">
        <div class="fiveimg"></div>
        <p>
          查看工程的实体质量，查阅内业资料，协助总结该工程在质量安全管理、节
          能环保、绿色施工、科技进步、技术创新、信息化、新型建造方式等方面的先
          进做法，提出提升建议和意见。提交咨询报告。
        </p>
      </div>
    </div>
    <mfooter></mfooter>
  </div>
</template>

<script>
import mheader from "../../components/mobileHF/mHeader";
import mfooter from "../../components/mobileHF/mFooter";
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {
    if (this.isMobile()) {
      this.$router.replace("/mProject"); //移动端跳转路由
    } else {
      this.$router.replace("/project"); //Pc端跳转路由
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  components: {
    mheader,
    mfooter,
  },
};
</script>

<style scoped lang="less">
.cmain {
  .topimg {
    width: 100%;
    height: 8.9rem;
    background: url("../../assets/img/mobile/mBanner/工程.png") 0 0 no-repeat;
    background-size: 100%;
  }
  .center {
    width: 100%;
    padding: 0rem 0.6rem;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 1rem;
    .title {
      opacity: 1;
      font-size: 1rem;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      text-align: center;
      color: #4279db;
      line-height: 1.4rem;
      margin: 1rem 0rem;
    }
    .jianjie {
      opacity: 1;
      font-size: 0.75rem;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      // font-weight: bolder;
      line-height: 1.3rem;
      text-align: justifyLeft;
      color: #231815;
    }
    .one {
      margin-top: 1.5rem;
    }
    .two {
      margin-top: 2rem;
    }
    .three {
      margin-top: 3rem;
    }
    .four {
      margin-top: 2.5rem;
    }
    .five {
      margin-top: 2.5rem;
      margin-bottom: 2.8rem;
    }
  }
}
p {
  text-indent: 2em;
  line-height: 1.2rem;
  opacity: 1;
  font-size: 0.7rem;
  font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
  font-weight: 400;
  text-align: justifyLeft;
  color: #333333;
}
.oneimg {
  width: 10rem;
  height: 1.5rem;
  background: url("../../assets/img/mobile/project/第一阶段@2x.png") 0 0
    no-repeat;
  background-size: 100%;
  margin-bottom: 1.2rem;
}
.twoimg {
  width: 13rem;
  height: 1.5rem;
  background: url("../../assets/img/mobile/project/第二阶段@2x.png") 0 0
    no-repeat;
  background-size: 100%;
  margin-bottom: 1.2rem;
}
.threeimg {
  width: 13rem;
  height: 1.5rem;
  background: url("../../assets/img/mobile/project/第三阶段@2x.png") 0 0
    no-repeat;
  background-size: 100%;
  margin-bottom: 1.2rem;
}
.fourimg {
  width: 18rem;
  height: 1.5rem;
  background: url("../../assets/img/mobile/project/第四阶段@2x.png") 0 0
    no-repeat;
  background-size: 100%;
  margin-bottom: 1.2rem;
}
.fiveimg {
  width: 13rem;
  height: 1.5rem;
  background: url("../../assets/img/mobile/project/第五阶段@2x.png") 0 0
    no-repeat;
  background-size: 100%;
  margin-bottom: 1.2rem;
}
</style>
